export function getDefaultShoppingListName(date = new Date()) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `Compras ${day}/${month}/${year}`;
}

/** Setores fixos de supermercado (exibidos no combobox de cada item). */
export const isShoppingItemFilled = (item) =>
    !!(item?.catalogItem?.name && item.catalogItem.name.trim() !== '');

export const getShoppingItemKey = (item) =>
    item?.id ?? item?._clientKey ?? '';

let clientKeySeq = 0;
export const nextShoppingItemClientKey = () => {
    clientKeySeq += 1;
    return `shopping-item-${clientKeySeq}`;
};

/**
 * Ordena itens preenchidos: por padrão não comprados primeiro, comprados no final.
 * Com coluna definida, ordena por ela (mantendo não comprados antes se coluna !== purchased).
 */
export function sortShoppingListItems(items, sortConfig = {}) {
    const {column = null, direction = 'asc'} = sortConfig;
    const emptyRows = (items || []).filter((item) => !isShoppingItemFilled(item));
    const filled = (items || []).filter((item) => isShoppingItemFilled(item));
    const mult = direction === 'desc' ? -1 : 1;

    filled.sort((a, b) => {
        if (column !== 'purchased') {
            const aPurchased = !!a.purchased;
            const bPurchased = !!b.purchased;
            if (aPurchased !== bPurchased) {
                return aPurchased ? 1 : -1;
            }
        }

        let cmp = 0;
        switch (column) {
        case 'purchased':
            cmp = (a.purchased ? 1 : 0) - (b.purchased ? 1 : 0);
            break;
        case 'item':
            cmp = (a.catalogItem?.name || '').localeCompare(
                b.catalogItem?.name || '',
                'pt-BR',
                {sensitivity: 'base'},
            );
            break;
        case 'sector':
            cmp = (a.supermarketSector || '').localeCompare(
                b.supermarketSector || '',
                'pt-BR',
                {sensitivity: 'base'},
            );
            break;
        case 'quantity':
            cmp = (parseInt(a.quantity, 10) || 0) - (parseInt(b.quantity, 10) || 0);
            break;
        default:
            cmp = (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            break;
        }
        return cmp * mult;
    });

    return [...filled, ...emptyRows];
}

export const SUPERMARKET_SECTORS = [
    'Hortifruti',
    'Açougue',
    'Peixaria',
    'Frios e laticínios',
    'Padaria',
    'Mercearia',
    'Bebidas',
    'Limpeza',
    'Higiene e beleza',
    'Congelados',
    'Bazar',
    'Pet shop',
    'Outros',
];
